import { AfterViewInit, Component, ChangeDetectorRef} from '@angular/core';

import { Language } from './language.model';
import { LanguageService } from '../services/language.service';
import { SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'core-language-selector',
  template: '<p-dropdown [options]="dropdownItems" [ngModel]="currentLanguageCode" (onChange)="onLanguageUpdated($event)"></p-dropdown>'
})
export class LanguageSelectorComponent implements AfterViewInit {
  languages: Language[] = [];
  dropdownItems: SelectItem[] = [];
  currentLanguageCode: string;

  constructor(  private languageService: LanguageService,
                private translateService: TranslateService,
                private changeDetectorRef: ChangeDetectorRef ) { }

  ngAfterViewInit() {
    this.languageService.getLanguages().subscribe(response => {
      this.languages = response;
      this.dropdownItems = [];
      this.languages.forEach(l => {
        this.dropdownItems.push({ label: l.name, value: l.code });
      });
    });

    this.currentLanguageCode = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe((e: any) => this.currentLanguageCode = e.lang);
    this.changeDetectorRef.detectChanges();
  }

  onLanguageUpdated(event: any): void {
    const newLanguageId = this.languages.find(l => l.code === event.value).id;
    this.languageService.changeLanguageTo(newLanguageId).subscribe(response => {
      this.translateService.use(response.code);
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/language-selector/language-selector.component.ts